import Resource from 'components/global/Resource'
import SectionTitle from 'components/global/SectionTitle'
import { Section, Row, Col } from 'components/grid'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext } from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'
import { documentsUnderReview } from '../../../constants'
import { sortToolkits } from 'components/core-adoption/functions/sortToolkits'

export default function EnglishToolkits({ ...props }) {
	const { account } = useContext(CoreAdoptionContext)

	return (
		<Section id={formatSectionId(props)} className="scroll-mt-14">
			<SectionTitle
				title="IRLA Foundational Skills Toolkits"
				text="IRLA Foundational Skills Toolkits offer targeted instructional resources based on students' needs, including foundational skills lessons for students who need them."
			/>
			<Row className="justify-center">
				{account?.toolkits &&
					account?.toolkits
						.filter((t) => t.active && t.language === 'english' && t.is_secondary === false)
						.sort(sortToolkits)
						.map((doc) => {
							return (
								<Col width="w-1/2 sm:w-1/3 md:w-1/6" className="mb-8" key={doc.name}>
									<Resource
										logResourceView={{ type: 'document' }}
										noLink={documentsUnderReview.includes(doc.name)}
										protected={!documentsUnderReview.includes(doc.name)}
										title={doc.name}
										text={documentsUnderReview.includes(doc.name) ? 'Under Revision for 2023' : doc.name}
									/>
								</Col>
							)
						})}
			</Row>
		</Section>
	)
}
